import { FC } from 'react';
import { Button } from 'antd';
import clsx from 'clsx';

import { TTableActionButtonProps } from './types.ts';

import styles from './styles.module.scss';

export const TableActionButton: FC<TTableActionButtonProps> = ({ icon, color, ...props }) => {
    return (
        <Button className={styles.tableActionButton} type="text" {...props}>
            <span
                className={clsx(styles.tableActionButtonIcon, {
                    [styles.tableActionButtonIconPrimary]: color === 'primary',
                    [styles.tableActionButtonIconDanger]: color === 'danger',
                })}
            >
                {icon}
            </span>
        </Button>
    );
};
